import React, { memo } from 'react';
import { useTranslation } from 'i18n';
import { Step } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CollapsibleStepper } from 'components/common/CollapsibleStepper';
import StepLabel from 'components/common/StepLabel';
import StepIcon from 'components/common/StepIcon';

interface IProps {
  activeStep?: number;
  collapsed?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  stepper: {
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      borderBottom: `1px solid ${theme.palette.custom.gray.light}`,
      width: '100%',
      zIndex: theme.zIndex.modal,
      top: 0,
      padding: '0 8px 0 0',
    },
  },
}));

const CheckoutCollapsibleStepper: React.FC<React.PropsWithChildren<IProps>> = ({ activeStep, collapsed }) => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');
  const steps = [t('creatingOrder.steps.0'), t('creatingOrder.steps.1'), t('creatingOrder.steps.2')];

  return (
    <CollapsibleStepper className={classes.stepper} collapsed={collapsed} activeStep={activeStep}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            StepIconComponent={StepIcon}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </CollapsibleStepper>
  );
};

export default memo(CheckoutCollapsibleStepper);
